import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
export default function LeftIcon({ detached, disabled, color, ...props }) {
    if (detached)
        return (_jsx(Flex, { position: "absolute", left: "0", bottom: "0", top: "0", backgroundColor: disabled ? "--semantic-disable-text" : "--surface-accent-dark", borderRadius: "8px 0 0 8px", padding: "0 16px", alignItems: "center", children: _jsx(Icon, { ...props, color: disabled ? "--neutral-white" : color }) }));
    return _jsx(Icon, { color: color, ...props });
}
//# sourceMappingURL=LeftIcon.js.map